import { Col, Row } from "reactstrap";

const Tecnologia = () => {
  return (
    <Row className="p-2">
      <Col xs={12} sm={6} className="px-5 mt-5">
        <p className="font-weight-bold">
          Sitema de monitorización inalámbrico y por Internet
        </p>
        <ul className="mt-3">
          <li>
            El sistema de control de los seguidores cuenta con comunicaciones
            inalámbricas mediante Wifi, lo que elimina la necesidad de cables de
            datos entre los seguidores y la unidad de toma de datos central,
            esta característica disminuye el coste de instalación del sistema de
            adquisición de datos, ya que no es necesario el tendido de cable y
            se eliminan las frecuentes interferencia causadas por la generación
            de energía en estos cables. La monitorización de los seguidores se
            realiza de manera simple a través de cualquier navegador y
            dispositivo conectado a Internet.
          </li>
        </ul>
      </Col>

      <Col xs={12} sm={6} className="px-5 mt-5">
        <p className="font-weight-bold">Backtracking</p>
        <ul class="mt-3">
          <li>
            La electrónica de seguimiento utilizada por Avantsolar, elimina el
            sombreado parcial de los módulos, lo que previene de la disminución
            de rendimiento del sistema. El sombreado parcial es practicamente
            imposible de eliminar en los seguidores de doble eje.
          </li>
        </ul>
      </Col>
    </Row>
  );
};

export default Tecnologia;
